<template>
  <div class="row mb-2 g-3">
    <slot></slot>
  </div>
</template>